import { createLoader, parseAsString } from 'nuqs/server';

/** Shared URL parsers for /settings (server loader + client useQueryStates). */
export const settingsSearchParamsParsers = {
  tab: parseAsString,
  'page-tab': parseAsString,
  appname: parseAsString,
  appName: parseAsString,
} as const;

export const loadSettingsSearchParams = createLoader(
  settingsSearchParamsParsers
);

export function settingsAppnameRaw(
  appname: string | null | undefined,
  appName: string | null | undefined
): string | undefined {
  return appname ?? appName ?? undefined;
}
